import {useSelector, useDispatch} from 'react-redux';

// Styles
import * as S from './HouseRules.styles';
import {BaseColumnWrap} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

// Components
import HotelPolicyModal from '../../../../../../stories/components/hotels/DetailsPageUnif/PolicyModal/PolicyModal';
import Modal, {useModal} from '@stencil/hotels-modal-component';
import HappyCheckPointIcon from '@stencil/icons/src/HappyCheckPointIcon/HappyCheckPointIcon';

// SELECTORS
import {
  hotelDetailsSelector,
  hotelStaticHouseRulesSelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';

// Thunk
import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/src';
import {
  detailsClick,
  DetailsPageComponents,
} from '@stencil/omniture-analytics/src/constants/details';

// Config

export default function HouseRules() {
  const {isModalOpen, closeModal, openModal} = useModal();
  const dispatch = useDispatch();
  const houseRules = useSelector(hotelStaticHouseRulesSelector);
  const hotelDetails = useSelector(hotelDetailsSelector);

  if (!houseRules || houseRules.length === 0) {
    return null;
  }

  const flexibleCheckinRules = hotelDetails?.flexibleCheckin?.rules || [];

  const mustReadRules = houseRules[0].rules;
  const totalLength = houseRules
    ?.filter(item => item?.rules)
    .reduce((totalLen, item) => {
      totalLen = item?.rules?.length + totalLen;
      return totalLen;
    }, 0);

  const morePolicyHandler = () => {
    dispatch(
      omnitureThunk(omnitureConfig.pages.DetailsUnif, omnitureConfig.events.ctaClick, {
        cta: {
          name: `${DetailsPageComponents.HouseRules}_${detailsClick.houseRules.morePoliciesModalClick}`,
          type: omnitureConfig.ctaType.Button,
          componentName: DetailsPageComponents.HouseRules,
          destination: '',
        },
      }),
    );
    openModal();
  };

  return (
    <>
      <BaseColumnWrap>
        <S.FeatureListUL>
          {flexibleCheckinRules?.map((rule, index) => (
            <li key={`fc_hr_${index}`}>
              <HappyCheckPointIcon {...S.staticCheckedIconProps} />
              <S.ListPara>{rule}</S.ListPara>
            </li>
          ))}
          {mustReadRules &&
            mustReadRules.slice(0, 5).map((rule, index) => (
              <li key={`hr_${index}`}>
                <HappyCheckPointIcon {...S.staticCheckedIconProps} />
                <S.ListPara>{rule?.text}</S.ListPara>
              </li>
            ))}
        </S.FeatureListUL>
      </BaseColumnWrap>
      <S.MorePolicyLink onClick={morePolicyHandler} data-testid="d-HouseRules-viewall">
        {`View all ${Number(totalLength - 5)} property policies`}
      </S.MorePolicyLink>
      <Modal
        isOpen={isModalOpen}
        closeModal={closeModal}
        modalStyles={{
          height: '61vh',
          width: '85rem',
        }}
        CloseButton={() => null}
      >
        <HotelPolicyModal houseRules={houseRules} closeModal={closeModal} />
      </Modal>
    </>
  );
}
